import { render } from "./d3-barchart.vue?vue&type=template&id=3fc93e39&scoped=true"
import script from "./d3-barchart.vue?vue&type=script&lang=js"
export * from "./d3-barchart.vue?vue&type=script&lang=js"

import "./d3-barchart.vue?vue&type=style&index=0&id=3fc93e39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc93e39"]])

export default __exports__